/** Settings → Manage tab (question editor). */
export const SETTINGS_TAB_MANAGE = 'manage';

export const settingsManageTabUrl = () => `/settings?tab=${SETTINGS_TAB_MANAGE}`;
